import { Border } from "./Border";
import { BoxShadow } from "./BoxShadow";
import { devices, sizes, deviceValue } from "./Breakpoints";
import { Colors } from "./Colors";
import { FlexboxGrid } from "./FlexboxGrid";
import { IconsSize } from "./IconsSize";
import { Radius } from "./Radius";
import { Spacing } from "./Spacing";
import { Typography } from "./Typography";

const Theme = {
    // COLORS
    color: Colors,

    // RADIUS
    radius: Radius,

    // BORDERS
    border: Border,

    // BOX SHADOW
    shadow: BoxShadow,

    // SPACING
    spacing: Spacing,

    // TYPOGRAPHY
    typography:Typography,

    // BREAKPOINTS
    devices: devices,
    deviceSize: sizes,
    deviceValue: deviceValue,

    // FLEXBOXGRID
    flexboxgrid: FlexboxGrid,

    // ICONS
    icons: IconsSize,

}

export default Theme;